module.exports = [{
      plugin: require('/tmp/79c24fe1/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('/tmp/79c24fe1/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/tmp/79c24fe1/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
